import * as TYPES from './mutationTypes'
// import Cookies from 'js-cookie' // cookie
import app from '@/apis/system'
import { isEmpty } from '@/utils/common'
export default {
  ToggleDevice({ commit }, device) {
    commit(TYPES.TOGGLE_DEVICE, device)
  },
  breadListAdd({ commit }, params) {
    commit(TYPES.BREADLISTADD, params)
  },
  breadListRemove({ commit }, params) {
    commit(TYPES.BREADLISTREMOVE, params)
  },
  breadListSet({ commit }, params) {
    commit(TYPES.BREADLISTSET, params)
  },
  updateUserInfo({ commit }, params) {
    commit(TYPES.USERINFO_UPDATE, params)
  },
  removeUserInfo({ commit }, params) {
    commit(TYPES.USERINFO_REMOVE, params)
  },
  updateTheme({ commit }, params) {
    commit(TYPES.THEME_UPDATE, params)
  },
  updateResourceList({ commit }, params) {
    commit(TYPES.RESOURCE_UPDATE, params)
  },
  removeResource({ commit }, params) {
    commit(TYPES.RESOURCE_REMOVE, params)
  },
  updateDecode({ commit }, params) {
    commit(TYPES.DECODE_UPDATE, params)
  },
  setNewContentAlert({ commit }, params) {
    commit(TYPES.NEW_CONTENT_ALERT, params)
  }
}
